/**
 * Created by cedricgodefroy on 27/10/2017.
 */

angular.module('FlexyBeautyApp.services').factory('LanguageManager_Resource', ["$resource", "$location", function ($resource, $location) {
    let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/lokalise/', {}, {
        getJsonFile: {method: 'POST', url: baseUrl + 'rest/lokalise/getJsonFile'}
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Countries', ["gettextCatalog",
    function (gettextCatalog) {

        let countries = {};

        countries.FRANCE = {
            countryCode: "FR",
            countryName: gettextCatalog.getString("France"),
            isSupported: false,
            onlinePaymentLink: "https://www.infogreffe.fr",
            shareholderDeclarationLink: "https://www.mangopay.com/terms/shareholder-declaration/Shareholder_Declaration-FR.pdf"
        };
        countries.BELGIUM = {
            countryCode: "BE",
            countryName: gettextCatalog.getString("Belgique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SWITZERLAND = {
            countryCode: "CH",
            countryName: gettextCatalog.getString("Suisse"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LUXEMBOURG = {
            countryCode: "LU",
            countryName: gettextCatalog.getString("Luxembourg"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.AFGHANISTAN = {
            countryCode: "AF",
            countryName: gettextCatalog.getString("Afghanistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOUTHAFRICA = {
            countryCode: "ZA",
            countryName: gettextCatalog.getString("Afrique du sud"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ALAND = {
            countryCode: "AX",
            countryName: gettextCatalog.getString("Åland, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ALBANIA = {
            countryCode: "AL",
            countryName: gettextCatalog.getString("Albanie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ALGERIA = {
            countryCode: "DZ",
            countryName: gettextCatalog.getString("Algérie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GERMANY = {
            countryCode: "DE",
            countryName: gettextCatalog.getString("Allemagne"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ANDORRA = {
            countryCode: "AD",
            countryName: gettextCatalog.getString("Andorre"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ANGOLA = {
            countryCode: "AO",
            countryName: gettextCatalog.getString("Angola"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ANGUILLA = {
            countryCode: "AI",
            countryName: gettextCatalog.getString("Anguilla"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ANTARCTICA = {
            countryCode: "AQ",
            countryName: gettextCatalog.getString("Antarctique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ANTIGUAANDBARBUDA = {
            countryCode: "AG",
            countryName: gettextCatalog.getString("Antigua et barbuda"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAUDIARABIA = {
            countryCode: "SA",
            countryName: gettextCatalog.getString("Arabie saoudite"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ARGENTINA = {
            countryCode: "AR",
            countryName: gettextCatalog.getString("Argentine"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ARMENIA = {
            countryCode: "AM",
            countryName: gettextCatalog.getString("Arménie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ARUBA = {
            countryCode: "AW",
            countryName: gettextCatalog.getString("Aruba"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.AUSTRALIA = {
            countryCode: "AU",
            countryName: gettextCatalog.getString("Australie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.AUSTRIA = {
            countryCode: "AT",
            countryName: gettextCatalog.getString("Autriche"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.AZERBAIJAN = {
            countryCode: "AZ",
            countryName: gettextCatalog.getString("Azerbaïdjan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BAHAMAS = {
            countryCode: "BS",
            countryName: gettextCatalog.getString("Bahamas"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BAHRAIN = {
            countryCode: "BH",
            countryName: gettextCatalog.getString("Bahreïn"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BANGLADECH = {
            countryCode: "BD",
            countryName: gettextCatalog.getString("Bangladesh"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BARBADOS = {
            countryCode: "BB",
            countryName: gettextCatalog.getString("Barbade"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BELARUS = {
            countryCode: "BY",
            countryName: gettextCatalog.getString("Bélarus"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BELIZE = {
            countryCode: "BZ",
            countryName: gettextCatalog.getString("Belize"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BENIN = {
            countryCode: "BJ",
            countryName: gettextCatalog.getString("Bénin"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BERMUDA = {
            countryCode: "BM",
            countryName: gettextCatalog.getString("Bermudes"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BHUTAN = {
            countryCode: "BT",
            countryName: gettextCatalog.getString("Bhoutan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BOLIVIA = {
            countryCode: "BO",
            countryName: gettextCatalog.getString("Bolivie, l'état plurinational de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BONAIRE = {
            countryCode: "BQ",
            countryName: gettextCatalog.getString("Bonaire, saint eustache et saba"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BOSNIAANDHERZEGOVINA = {
            countryCode: "BA",
            countryName: gettextCatalog.getString("Bosnie herzégovine"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BOTSWANA = {
            countryCode: "BW",
            countryName: gettextCatalog.getString("Botswana"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        },
            countries.BOUVET = {
                countryCode: "BV",
                countryName: gettextCatalog.getString("Bouvet, île"),
                isSupported: false,
                onlinePaymentLink: null,
                shareholderDeclarationLink: null
            };
        countries.BRAZIL = {
            countryCode: "BR",
            countryName: gettextCatalog.getString("Brésil"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BRUNEIDARUSSALAM = {
            countryCode: "BN",
            countryName: gettextCatalog.getString("Brunei darussalam"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BULGARIA = {
            countryCode: "BG",
            countryName: gettextCatalog.getString("Bulgarie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BURKINAFASO = {
            countryCode: "BF",
            countryName: gettextCatalog.getString("Burkina faso"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BURUNDI = {
            countryCode: "BI",
            countryName: gettextCatalog.getString("Burundi"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CAYMAN = {
            countryCode: "KY",
            countryName: gettextCatalog.getString("Caïmans, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CAMBODIA = {
            countryCode: "KH",
            countryName: gettextCatalog.getString("Cambodge"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CAMEROUN = {
            countryCode: "CM",
            countryName: gettextCatalog.getString("Cameroun"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CANADA = {
            countryCode: "CA",
            countryName: gettextCatalog.getString("Canada"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CAPEVERDE = {
            countryCode: "CV",
            countryName: gettextCatalog.getString("Cap vert"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CENTRALAFRICANREPUBLIC = {
            countryCode: "CF",
            countryName: gettextCatalog.getString("Centrafricaine, république"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CHILI = {
            countryCode: "CL",
            countryName: gettextCatalog.getString("Chili"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CHINA = {
            countryCode: "CN",
            countryName: gettextCatalog.getString("Chine"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CHRISTMASISLAND = {
            countryCode: "CX",
            countryName: gettextCatalog.getString("Christmas, île"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CYPRUS = {
            countryCode: "CY",
            countryName: gettextCatalog.getString("Chypre"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.COCOSISLANDS = {
            countryCode: "CC",
            countryName: gettextCatalog.getString("Cocos (keeling), îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.COLOMBIA = {
            countryCode: "CO",
            countryName: gettextCatalog.getString("Colombie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.COMOROS = {
            countryCode: "KM",
            countryName: gettextCatalog.getString("Comores"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CONGO = {
            countryCode: "CG",
            countryName: gettextCatalog.getString("Congo"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.DEMOCRATICREPUBLICOFTHECONGO = {
            countryCode: "CD",
            countryName: gettextCatalog.getString("Congo, la république démocratique du"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.COOKISLANDS = {
            countryCode: "CK",
            countryName: gettextCatalog.getString("Cook, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOUTHKOREA = {
            countryCode: "KR",
            countryName: gettextCatalog.getString("Corée, république de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NORTHKOREA = {
            countryCode: "KP",
            countryName: gettextCatalog.getString("Corée, république populaire démocratique de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.COSTARICA = {
            countryCode: "CR",
            countryName: gettextCatalog.getString("Costa rica"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.IVORYCOAST = {
            countryCode: "CI",
            countryName: gettextCatalog.getString("Côte d'ivoire"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CROATIA = {
            countryCode: "HR",
            countryName: gettextCatalog.getString("Croatie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CUBA = {
            countryCode: "CU",
            countryName: gettextCatalog.getString("Cuba"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CUARCAO = {
            countryCode: "CW",
            countryName: gettextCatalog.getString("Curaçao"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.DENMARK = {
            countryCode: "DK",
            countryName: gettextCatalog.getString("Danemark"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.DJIBOUTI = {
            countryCode: "DJ",
            countryName: gettextCatalog.getString("Djibouti"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.DOMINICANREPUBLIC = {
            countryCode: "DO",
            countryName: gettextCatalog.getString("Dominicaine, république"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.DOMINICA = {
            countryCode: "DM",
            countryName: gettextCatalog.getString("Dominique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.EGYPT = {
            countryCode: "EG",
            countryName: gettextCatalog.getString("Égypte"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ELSALVADOR = {
            countryCode: "SV",
            countryName: gettextCatalog.getString("El salvador"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UNITEDARABEMIRATES = {
            countryCode: "AE",
            countryName: gettextCatalog.getString("Émirats arabes unis"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ECUADOR = {
            countryCode: "EC",
            countryName: gettextCatalog.getString("Équateur"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ERITREA = {
            countryCode: "ER",
            countryName: gettextCatalog.getString("Érythrée"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SPAIN = {
            countryCode: "ES",
            countryName: gettextCatalog.getString("Espagne"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ESTONIA = {
            countryCode: "EE",
            countryName: gettextCatalog.getString("Estonie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UNITEDSTATESOFAMERICA = {
            countryCode: "US",
            countryName: gettextCatalog.getString("États unis"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ETHIOPIA = {
            countryCode: "ET",
            countryName: gettextCatalog.getString("Éthiopie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FALKLANDISLANDS = {
            countryCode: "FK",
            countryName: gettextCatalog.getString("Falkland, îles (malvinas)"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FAROEISLANDS = {
            countryCode: "FO",
            countryName: gettextCatalog.getString("Féroé, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FIJI = {
            countryCode: "FJ",
            countryName: gettextCatalog.getString("Fidji"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FINLAND = {
            countryCode: "FI",
            countryName: gettextCatalog.getString("Finlande"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GABON = {
            countryCode: "GA",
            countryName: gettextCatalog.getString("Gabon"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GAMBIA = {
            countryCode: "GM",
            countryName: gettextCatalog.getString("Gambie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GEORGIA = {
            countryCode: "GE",
            countryName: gettextCatalog.getString("Géorgie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOUTHGEORGIA = {
            countryCode: "GS",
            countryName: gettextCatalog.getString("Géorgie du sud et les îles sandwich du sud"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GHANA = {
            countryCode: "GH",
            countryName: gettextCatalog.getString("Ghana"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GIBRALTAR = {
            countryCode: "GI",
            countryName: gettextCatalog.getString("Gibraltar"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GREECE = {
            countryCode: "GR",
            countryName: gettextCatalog.getString("Grèce"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GRENADA = {
            countryCode: "GD",
            countryName: gettextCatalog.getString("Grenade"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GREENLAND = {
            countryCode: "GL",
            countryName: gettextCatalog.getString("Groenland"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUADELOUPE = {
            countryCode: "GP",
            countryName: gettextCatalog.getString("Guadeloupe"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUAM = {
            countryCode: "GU",
            countryName: gettextCatalog.getString("Guam"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUATEMALA = {
            countryCode: "GT",
            countryName: gettextCatalog.getString("Guatemala"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUERNSEY = {
            countryCode: "GG",
            countryName: gettextCatalog.getString("Guernesey"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUINEA = {
            countryCode: "GN",
            countryName: gettextCatalog.getString("Guinée"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUINEABISSAU = {
            countryCode: "GW",
            countryName: gettextCatalog.getString("Guinée bissau"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.EQUATORIALGUINEA = {
            countryCode: "GQ",
            countryName: gettextCatalog.getString("Guinée équatoriale"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.GUYANA = {
            countryCode: "GY",
            countryName: gettextCatalog.getString("Guyana"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FRENCHGUIANA = {
            countryCode: "GF",
            countryName: gettextCatalog.getString("Guyane française"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HAITI = {
            countryCode: "HT",
            countryName: gettextCatalog.getString("Haïti"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HEARDISLANDANDMCDONALDISLANDS = {
            countryCode: "HM",
            countryName: gettextCatalog.getString("Heard et îles macdonald, île"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HONDOURAS = {
            countryCode: "HN",
            countryName: gettextCatalog.getString("Honduras"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HONGKONG = {
            countryCode: "HK",
            countryName: gettextCatalog.getString("Hong kong"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HUNGARY = {
            countryCode: "HU",
            countryName: gettextCatalog.getString("Hongrie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ISLEOFMAN = {
            countryCode: "IM",
            countryName: gettextCatalog.getString("Île de man"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MINOROUTLYINGISLANDSUNITEDSTATES = {
            countryCode: "UM",
            countryName: gettextCatalog.getString("Îles mineures éloignées des états unis"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BRITISHVIRGINISLANDS = {
            countryCode: "VG",
            countryName: gettextCatalog.getString("Îles vierges britanniques"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.USAVIRGINISLANDS = {
            countryCode: "VI",
            countryName: gettextCatalog.getString("Îles vierges des états unis"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.INDIA = {
            countryCode: "IN",
            countryName: gettextCatalog.getString("Inde"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.INDONESIA = {
            countryCode: "ID",
            countryName: gettextCatalog.getString("Indonésie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.IRAN = {
            countryCode: "IR",
            countryName: gettextCatalog.getString("Iran, république islamique d'"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.IRAQ = {
            countryCode: "IQ",
            countryName: gettextCatalog.getString("Iraq"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.IRELAND = {
            countryCode: "IE",
            countryName: gettextCatalog.getString("Irlande"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ICELAND = {
            countryCode: "IS",
            countryName: gettextCatalog.getString("Islande"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ISRAEL = {
            countryCode: "IL",
            countryName: gettextCatalog.getString("Israël"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ITALIA = {
            countryCode: "IT",
            countryName: gettextCatalog.getString("Italie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.JAMAICA = {
            countryCode: "JM",
            countryName: gettextCatalog.getString("Jamaïque"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.JAPAN = {
            countryCode: "JP",
            countryName: gettextCatalog.getString("Japon"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.JERSEY = {
            countryCode: "JE",
            countryName: gettextCatalog.getString("Jersey"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.JORDAN = {
            countryCode: "JO",
            countryName: gettextCatalog.getString("Jordanie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.KAZAKHSTAN = {
            countryCode: "KZ",
            countryName: gettextCatalog.getString("Kazakhstan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.KENYA = {
            countryCode: "KE",
            countryName: gettextCatalog.getString("Kenya"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.KYRGYZSTAN = {
            countryCode: "KG",
            countryName: gettextCatalog.getString("Kirghizistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.KIRIBATI = {
            countryCode: "KI",
            countryName: gettextCatalog.getString("Kiribati"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.KUWAIT = {
            countryCode: "KW",
            countryName: gettextCatalog.getString("Koweït"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LAO = {
            countryCode: "LA",
            countryName: gettextCatalog.getString("Lao, république démocratique populaire"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LESOTHO = {
            countryCode: "LS",
            countryName: gettextCatalog.getString("Lesotho"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LATVIA = {
            countryCode: "LV",
            countryName: gettextCatalog.getString("Lettonie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LEBANON = {
            countryCode: "LB",
            countryName: gettextCatalog.getString("Liban"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LIBERIA = {
            countryCode: "LR",
            countryName: gettextCatalog.getString("Libéria"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LIBYA = {
            countryCode: "LY",
            countryName: gettextCatalog.getString("Libye"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LIECHTENSTEIN = {
            countryCode: "LI",
            countryName: gettextCatalog.getString("Liechtenstein"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.LITHUANIA = {
            countryCode: "LT",
            countryName: gettextCatalog.getString("Lituanie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MACAU = {
            countryCode: "MO",
            countryName: gettextCatalog.getString("Macao"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MACEDONIA = {
            countryCode: "MK",
            countryName: gettextCatalog.getString("Macédoine, l'ex république yougoslave de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MADAGASCAR = {
            countryCode: "MG",
            countryName: gettextCatalog.getString("Madagascar"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MALISIA = {
            countryCode: "MY",
            countryName: gettextCatalog.getString("Malaisie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MALAWI = {
            countryCode: "MW",
            countryName: gettextCatalog.getString("Malawi"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MALDIVES = {
            countryCode: "MV",
            countryName: gettextCatalog.getString("Maldives"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MALI = {
            countryCode: "ML",
            countryName: gettextCatalog.getString("Mali"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MALTA = {
            countryCode: "MT",
            countryName: gettextCatalog.getString("Malte"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NORTHERNMARIANAISLANDS = {
            countryCode: "MP",
            countryName: gettextCatalog.getString("Mariannes du nord, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MAROCO = {
            countryCode: "MA",
            countryName: gettextCatalog.getString("Maroc"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MARSHALL = {
            countryCode: "MH",
            countryName: gettextCatalog.getString("Marshall, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MARTINIQUE = {
            countryCode: "MQ",
            countryName: gettextCatalog.getString("Martinique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MAURITIUS = {
            countryCode: "MU",
            countryName: gettextCatalog.getString("Maurice"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MAURITANIA = {
            countryCode: "MR",
            countryName: gettextCatalog.getString("Mauritanie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MAYOTTE = {
            countryCode: "YT",
            countryName: gettextCatalog.getString("Mayotte"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MEXICO = {
            countryCode: "MX",
            countryName: gettextCatalog.getString("Mexique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MICRONESIAFEDERALSTATESOF = {
            countryCode: "FM",
            countryName: gettextCatalog.getString("Micronésie, états fédérés de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MOLDOVA = {
            countryCode: "MD",
            countryName: gettextCatalog.getString("Moldova, république de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MONACO = {
            countryCode: "MC",
            countryName: gettextCatalog.getString("Monaco"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MONGOLIA = {
            countryCode: "MN",
            countryName: gettextCatalog.getString("Mongolie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MONTENEGRO = {
            countryCode: "ME",
            countryName: gettextCatalog.getString("Monténégro"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MONTSERRAT = {
            countryCode: "MS",
            countryName: gettextCatalog.getString("Montserrat"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MOZAMBIQUE = {
            countryCode: "MZ",
            countryName: gettextCatalog.getString("Mozambique"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.MYNAMAR = {
            countryCode: "MM",
            countryName: gettextCatalog.getString("Myanmar"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NAMIBIA = {
            countryCode: "NA",
            countryName: gettextCatalog.getString("Namibie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NAURU = {
            countryCode: "NR",
            countryName: gettextCatalog.getString("Nauru"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NEPAL = {
            countryCode: "NP",
            countryName: gettextCatalog.getString("Népal"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NICARAGUA = {
            countryCode: "NI",
            countryName: gettextCatalog.getString("Nicaragua"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NIGER = {
            countryCode: "NE",
            countryName: gettextCatalog.getString("Niger"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NIGERIA = {
            countryCode: "NG",
            countryName: gettextCatalog.getString("Nigéria"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NIUE = {
            countryCode: "NU",
            countryName: gettextCatalog.getString("Niué"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NOFOLKISLAND = {
            countryCode: "NF",
            countryName: gettextCatalog.getString("Norfolk, île"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NORWAY = {
            countryCode: "NO",
            countryName: gettextCatalog.getString("Norvège"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NEWCALEDONIA = {
            countryCode: "NC",
            countryName: gettextCatalog.getString("Nouvelle calédonie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NEWZEALAND = {
            countryCode: "NZ",
            countryName: gettextCatalog.getString("Nouvelle zélande"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BRITISHINDIANOCEANTERRITORY = {
            countryCode: "IO",
            countryName: gettextCatalog.getString("Océan indien, territoire britannique de l'"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.OMAN = {
            countryCode: "OM",
            countryName: gettextCatalog.getString("Oman"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UGANDA = {
            countryCode: "UG",
            countryName: gettextCatalog.getString("Ouganda"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UZBEKISTAN = {
            countryCode: "UZ",
            countryName: gettextCatalog.getString("Ouzbékistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PAKISTAN = {
            countryCode: "PK",
            countryName: gettextCatalog.getString("Pakistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PALAU = {
            countryCode: "PW",
            countryName: gettextCatalog.getString("Palaos"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PALESTINIANTERRITORIES = {
            countryCode: "PS",
            countryName: gettextCatalog.getString("Palestinien occupé, territoire"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PANAMA = {
            countryCode: "PA",
            countryName: gettextCatalog.getString("Panama"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PAPUANEWGUINEA = {
            countryCode: "PG",
            countryName: gettextCatalog.getString("Papouasie nouvelle guinée"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PARAGUAY = {
            countryCode: "PY",
            countryName: gettextCatalog.getString("Paraguay"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.NETHERLANDS = {
            countryCode: "NL",
            countryName: gettextCatalog.getString("Pays bas"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PERU = {
            countryCode: "PE",
            countryName: gettextCatalog.getString("Pérou"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PHILIPPINES = {
            countryCode: "PH",
            countryName: gettextCatalog.getString("Philippines"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PITCAIRNISLAND = {
            countryCode: "PN",
            countryName: gettextCatalog.getString("Pitcairn"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.POLAND = {
            countryCode: "PL",
            countryName: gettextCatalog.getString("Pologne"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FRENCHPOLYNESIA = {
            countryCode: "PF",
            countryName: gettextCatalog.getString("Polynésie française"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PORTORICO = {
            countryCode: "PR",
            countryName: gettextCatalog.getString("Porto rico"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.PORTUGAL = {
            countryCode: "PT",
            countryName: gettextCatalog.getString("Portugal"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.QATAR = {
            countryCode: "QA",
            countryName: gettextCatalog.getString("Qatar"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.REUNIONISLAND = {
            countryCode: "RE",
            countryName: gettextCatalog.getString("Réunion"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ROMANIA = {
            countryCode: "RO",
            countryName: gettextCatalog.getString("Roumanie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UNITEDKINGDOM = {
            countryCode: "GB",
            countryName: gettextCatalog.getString("Royaume uni"),
            isSupported: false,
            onlinePaymentLink: "https://beta.companieshouse.gov.uk/",
            shareholderDeclarationLink: null
        };
        countries.RUSSIA = {
            countryCode: "RU",
            countryName: gettextCatalog.getString("Russie, fédération de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.RWANDA = {
            countryCode: "RW",
            countryName: gettextCatalog.getString("Rwanda"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.WESTERNSAHARA = {
            countryCode: "EH",
            countryName: gettextCatalog.getString("Sahara occidental"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STBARTHOLOMEW = {
            countryCode: "BL",
            countryName: gettextCatalog.getString("Saint barthélemy"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAINTHELENA = {
            countryCode: "SH",
            countryName: gettextCatalog.getString("Sainte hélène, ascension et tristan da cunha"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STLUCIA = {
            countryCode: "LC",
            countryName: gettextCatalog.getString("Sainte lucie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STKITTS = {
            countryCode: "KN",
            countryName: gettextCatalog.getString("Saint kitts et nevis"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STMARINO = {
            countryCode: "SM",
            countryName: gettextCatalog.getString("Saint marin"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STMARINOFRENCHPART = {
            countryCode: "MF",
            countryName: gettextCatalog.getString("Saint martin(partie française)"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.STMARINODUTCHPART = {
            countryCode: "SX",
            countryName: gettextCatalog.getString("Saint martin (partie néerlandaise)"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAINTPIERREANDMIQUELON = {
            countryCode: "PM",
            countryName: gettextCatalog.getString("Saint pierre et miquelon"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.HOLYSEESTATEOFTHECITYOFVATICAN = {
            countryCode: "VA",
            countryName: gettextCatalog.getString("Saint siège (état de la cité du vatican)"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAINTVINCENTANDTHEGRENADINES = {
            countryCode: "VC",
            countryName: gettextCatalog.getString("Saint vincent et les grenadines"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOLOMONISLANDS = {
            countryCode: "SB",
            countryName: gettextCatalog.getString("Salomon, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAMOA = {
            countryCode: "WS",
            countryName: gettextCatalog.getString("Samoa"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.AMERICANSAMOA = {
            countryCode: "AS",
            countryName: gettextCatalog.getString("Samoa américaines"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SAOTOMEANDPRINCIPE = {
            countryCode: "ST",
            countryName: gettextCatalog.getString("Sao tomé et principe"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SENEGAL = {
            countryCode: "SN",
            countryName: gettextCatalog.getString("Sénégal"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SERBIA = {
            countryCode: "RS",
            countryName: gettextCatalog.getString("Serbie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SEYCHELLES = {
            countryCode: "SC",
            countryName: gettextCatalog.getString("Seychelles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SIERRALEONE = {
            countryCode: "SL",
            countryName: gettextCatalog.getString("Sierra leone"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SINGAPORE = {
            countryCode: "SG",
            countryName: gettextCatalog.getString("Singapour"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SLOVAKIA = {
            countryCode: "SK",
            countryName: gettextCatalog.getString("Slovaquie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SLOVENIA = {
            countryCode: "SI",
            countryName: gettextCatalog.getString("Slovénie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOMALIA = {
            countryCode: "SO",
            countryName: gettextCatalog.getString("Somalie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SUDAN = {
            countryCode: "SD",
            countryName: gettextCatalog.getString("Soudan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SOUTHSUDAN = {
            countryCode: "SS",
            countryName: gettextCatalog.getString("Soudan du sud"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SRILANKA = {
            countryCode: "LK",
            countryName: gettextCatalog.getString("Sri lanka"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SWEDEN = {
            countryCode: "SE",
            countryName: gettextCatalog.getString("Suède"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SURINAME = {
            countryCode: "SR",
            countryName: gettextCatalog.getString("Suriname"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SVALBARDANDJANMAYEN = {
            countryCode: "SJ",
            countryName: gettextCatalog.getString("Svalbard et île jan mayen"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SWAZILAND = {
            countryCode: "SZ",
            countryName: gettextCatalog.getString("Swaziland"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.SYRIA = {
            countryCode: "SY",
            countryName: gettextCatalog.getString("Syrienne, république arabe"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TAJIKISTAN = {
            countryCode: "TJ",
            countryName: gettextCatalog.getString("Tadjikistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TAIWAN = {
            countryCode: "TW",
            countryName: gettextCatalog.getString("Taïwan, province de chine"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TANZANIA = {
            countryCode: "TZ",
            countryName: gettextCatalog.getString("Tanzanie, république unie de"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.CHAD = {
            countryCode: "TD",
            countryName: gettextCatalog.getString("Tchad"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.BELIZE = {
            CZECHREPUBLIC: "CZ",
            countryName: gettextCatalog.getString("Tchèque, république"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.FRENCHSOUTHERNTERRITORIES = {
            countryCode: "TF",
            countryName: gettextCatalog.getString("Terres australes françaises"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.THAILAND = {
            countryCode: "TH",
            countryName: gettextCatalog.getString("Thaïlande"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TIMORLESTE = {
            countryCode: "TL",
            countryName: gettextCatalog.getString("Timor leste"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TOGO = {
            countryCode: "TG",
            countryName: gettextCatalog.getString("Togo"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TOKELAU = {
            countryCode: "TK",
            countryName: gettextCatalog.getString("Tokelau"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TONGA = {
            countryCode: "TO",
            countryName: gettextCatalog.getString("Tonga"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TRINIDADANDTOBAGO = {
            countryCode: "TT",
            countryName: gettextCatalog.getString("Trinité et tobago"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TUNISIA = {
            countryCode: "TN",
            countryName: gettextCatalog.getString("Tunisie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TURKMENISTAN = {
            countryCode: "TM",
            countryName: gettextCatalog.getString("Turkménistan"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TURKSANDCAICOSISLANDS = {
            countryCode: "TC",
            countryName: gettextCatalog.getString("Turks et caïcos, îles"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TURKEY = {
            countryCode: "TR",
            countryName: gettextCatalog.getString("Turquie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.TUVALU = {
            countryCode: "TV",
            countryName: gettextCatalog.getString("Tuvalu"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.UKRAINE = {
            countryCode: "UA",
            countryName: gettextCatalog.getString("Ukraine"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.URUGUAY = {
            countryCode: "UY",
            countryName: gettextCatalog.getString("Uruguay"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.VANUATU = {
            countryCode: "VU",
            countryName: gettextCatalog.getString("Vanuatu"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.VENEZUELA = {
            countryCode: "VE",
            countryName: gettextCatalog.getString("Venezuela, république bolivarienne du"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.VIETNAM = {
            countryCode: "VN",
            countryName: gettextCatalog.getString("Viet nam"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.WALLISANDFUTUNAISLANDS = {
            countryCode: "WF",
            countryName: gettextCatalog.getString("Wallis et futuna"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.YEMEN = {
            countryCode: "YE",
            countryName: gettextCatalog.getString("Yémen"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ZAMBIA = {
            countryCode: "ZM",
            countryName: gettextCatalog.getString("Zambie"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        };
        countries.ZIMBABWE = {
            countryCode: "ZW",
            countryName: gettextCatalog.getString("Zimbabwe​​​​​"),
            isSupported: false,
            onlinePaymentLink: null,
            shareholderDeclarationLink: null
        }

        countries.map = [];
        countries.map[countries.FRANCE.countryCode] = countries.FRANCE;
        countries.map[countries.BELGIUM.countryCode] = countries.BELGIUM;
        countries.map[countries.SWITZERLAND.countryCode] = countries.SWITZERLAND;
        countries.map[countries.LUXEMBOURG.countryCode] = countries.LUXEMBOURG;
        countries.map[countries.AFGHANISTAN.countryCode] = countries.AFGHANISTAN;
        countries.map[countries.SOUTHAFRICA.countryCode] = countries.SOUTHAFRICA;
        countries.map[countries.ALAND.countryCode] = countries.ALAND;
        countries.map[countries.ALBANIA.countryCode] = countries.ALBANIA;
        countries.map[countries.ALGERIA.countryCode] = countries.ALGERIA;
        countries.map[countries.GERMANY.countryCode] = countries.GERMANY;
        countries.map[countries.ANDORRA.countryCode] = countries.ANDORRA;
        countries.map[countries.ANGOLA.countryCode] = countries.ANGOLA;
        countries.map[countries.ANGUILLA.countryCode] = countries.ANGUILLA;
        countries.map[countries.ANTARCTICA.countryCode] = countries.ANTARCTICA;
        countries.map[countries.ANTIGUAANDBARBUDA.countryCode] = countries.ANTIGUAANDBARBUDA;
        countries.map[countries.SAUDIARABIA.countryCode] = countries.SAUDIARABIA;
        countries.map[countries.ARGENTINA.countryCode] = countries.ARGENTINA;
        countries.map[countries.ARMENIA.countryCode] = countries.ARMENIA;
        countries.map[countries.ARUBA.countryCode] = countries.ARUBA;
        countries.map[countries.AUSTRALIA.countryCode] = countries.AUSTRALIA;
        countries.map[countries.AUSTRIA.countryCode] = countries.AUSTRIA;
        countries.map[countries.AZERBAIJAN.countryCode] = countries.AZERBAIJAN;
        countries.map[countries.BAHAMAS.countryCode] = countries.BAHAMAS;
        countries.map[countries.BAHRAIN.countryCode] = countries.BAHRAIN;
        countries.map[countries.BANGLADECH.countryCode] = countries.BANGLADECH;
        countries.map[countries.BARBADOS.countryCode] = countries.BARBADOS;
        countries.map[countries.BELARUS.countryCode] = countries.BELARUS;
        countries.map[countries.BELIZE.countryCode] = countries.BELIZE;
        countries.map[countries.BENIN.countryCode] = countries.BENIN;
        countries.map[countries.BERMUDA.countryCode] = countries.BERMUDA;
        countries.map[countries.BHUTAN.countryCode] = countries.BHUTAN;
        countries.map[countries.BOLIVIA.countryCode] = countries.BOLIVIA;
        countries.map[countries.BONAIRE.countryCode] = countries.BONAIRE;
        countries.map[countries.BOSNIAANDHERZEGOVINA.countryCode] = countries.BOSNIAANDHERZEGOVINA;
        countries.map[countries.BOTSWANA.countryCode] = countries.BOTSWANA;
        countries.map[countries.BOUVET.countryCode] = countries.BOUVET;
        countries.map[countries.BRAZIL.countryCode] = countries.BRAZIL;
        countries.map[countries.BRUNEIDARUSSALAM.countryCode] = countries.BRUNEIDARUSSALAM;
        countries.map[countries.BULGARIA.countryCode] = countries.BULGARIA;
        countries.map[countries.BURKINAFASO.countryCode] = countries.BURKINAFASO;
        countries.map[countries.BURUNDI.countryCode] = countries.BURUNDI;
        countries.map[countries.CAYMAN.countryCode] = countries.CAYMAN;
        countries.map[countries.CAMBODIA.countryCode] = countries.CAMBODIA;
        countries.map[countries.CAMEROUN.countryCode] = countries.CAMEROUN;
        countries.map[countries.CANADA.countryCode] = countries.CANADA;
        countries.map[countries.CAPEVERDE.countryCode] = countries.CAPEVERDE;
        countries.map[countries.CENTRALAFRICANREPUBLIC.countryCode] = countries.CENTRALAFRICANREPUBLIC;
        countries.map[countries.CHILI.countryCode] = countries.CHILI;
        countries.map[countries.CHINA.countryCode] = countries.CHINA;
        countries.map[countries.CHRISTMASISLAND.countryCode] = countries.CHRISTMASISLAND;
        countries.map[countries.CYPRUS.countryCode] = countries.CYPRUS
        countries.map[countries.COCOSISLANDS.countryCode] = countries.COCOSISLANDS;
        countries.map[countries.COLOMBIA.countryCode] = countries.COLOMBIA;
        countries.map[countries.COMOROS.countryCode] = countries.COMOROS;
        countries.map[countries.CONGO.countryCode] = countries.CONGO;
        countries.map[countries.DEMOCRATICREPUBLICOFTHECONGO.countryCode] = countries.DEMOCRATICREPUBLICOFTHECONGO;
        countries.map[countries.COOKISLANDS.countryCode] = countries.COOKISLANDS;
        countries.map[countries.SOUTHKOREA.countryCode] = countries.SOUTHKOREA;
        countries.map[countries.NORTHKOREA.countryCode] = countries.NORTHKOREA;
        countries.map[countries.COSTARICA.countryCode] = countries.COSTARICA;
        countries.map[countries.IVORYCOAST.countryCode] = countries.IVORYCOAST;
        countries.map[countries.CROATIA.countryCode] = countries.CROATIA;
        countries.map[countries.CUBA.countryCode] = countries.CUBA;
        countries.map[countries.CUARCAO.countryCode] = countries.CUARCAO;
        countries.map[countries.DENMARK.countryCode] = countries.DENMARK;
        countries.map[countries.DJIBOUTI.countryCode] = countries.DJIBOUTI;
        countries.map[countries.DOMINICANREPUBLIC.countryCode] = countries.DOMINICANREPUBLIC;
        countries.map[countries.DOMINICA.countryCode] = countries.DOMINICA;
        countries.map[countries.EGYPT.countryCode] = countries.EGYPT;
        countries.map[countries.ELSALVADOR.countryCode] = countries.ELSALVADOR;
        countries.map[countries.UNITEDARABEMIRATES.countryCode] = countries.UNITEDARABEMIRATES;
        countries.map[countries.ECUADOR.countryCode] = countries.ECUADOR;
        countries.map[countries.ERITREA.countryCode] = countries.ERITREA;
        countries.map[countries.SPAIN.countryCode] = countries.SPAIN;
        countries.map[countries.ESTONIA.countryCode] = countries.ESTONIA;
        countries.map[countries.UNITEDSTATESOFAMERICA.countryCode] = countries.UNITEDSTATESOFAMERICA;
        countries.map[countries.ETHIOPIA.countryCode] = countries.ETHIOPIA;
        countries.map[countries.FALKLANDISLANDS.countryCode] = countries.FALKLANDISLANDS;
        countries.map[countries.FAROEISLANDS.countryCode] = countries.FAROEISLANDS;
        countries.map[countries.FIJI.countryCode] = countries.FIJI;
        countries.map[countries.FINLAND.countryCode] = countries.FINLAND;
        countries.map[countries.GABON.countryCode] = countries.GABON;
        countries.map[countries.GAMBIA.countryCode] = countries.GAMBIA;
        countries.map[countries.GEORGIA.countryCode] = countries.GEORGIA;
        countries.map[countries.SOUTHGEORGIA.countryCode] = countries.SOUTHGEORGIA;
        countries.map[countries.GHANA.countryCode] = countries.GHANA;
        countries.map[countries.GIBRALTAR.countryCode] = countries.GIBRALTAR;
        countries.map[countries.GREECE.countryCode] = countries.GREECE;
        countries.map[countries.GRENADA.countryCode] = countries.GRENADA;
        countries.map[countries.GREENLAND.countryCode] = countries.GREENLAND;
        countries.map[countries.GUADELOUPE.countryCode] = countries.GUADELOUPE;
        countries.map[countries.GUAM.countryCode] = countries.GUAM;
        countries.map[countries.GUATEMALA.countryCode] = countries.GUATEMALA;
        countries.map[countries.GUERNSEY.countryCode] = countries.GUERNSEY;
        countries.map[countries.GUINEA.countryCode] = countries.GUINEA;
        countries.map[countries.GUINEABISSAU.countryCode] = countries.GUINEABISSAU;
        countries.map[countries.EQUATORIALGUINEA.countryCode] = countries.EQUATORIALGUINEA;
        countries.map[countries.GUYANA.countryCode] = countries.GUYANA;
        countries.map[countries.FRENCHGUIANA.countryCode] = countries.FRENCHGUIANA;
        countries.map[countries.HAITI.countryCode] = countries.HAITI;
        countries.map[countries.HEARDISLANDANDMCDONALDISLANDS.countryCode] = countries.HEARDISLANDANDMCDONALDISLANDS;
        countries.map[countries.HONDOURAS.countryCode] = countries.HONDOURAS;
        countries.map[countries.HONGKONG.countryCode] = countries.HONGKONG;
        countries.map[countries.HUNGARY.countryCode] = countries.HUNGARY;
        countries.map[countries.ISLEOFMAN.countryCode] = countries.ISLEOFMAN;
        countries.map[countries.MINOROUTLYINGISLANDSUNITEDSTATES.countryCode] = countries.MINOROUTLYINGISLANDSUNITEDSTATES;
        countries.map[countries.BRITISHVIRGINISLANDS.countryCode] = countries.BRITISHVIRGINISLANDS;
        countries.map[countries.USAVIRGINISLANDS.countryCode] = countries.USAVIRGINISLANDS;
        countries.map[countries.INDIA.countryCode] = countries.INDIA;
        countries.map[countries.INDONESIA.countryCode] = countries.INDONESIA;
        countries.map[countries.IRAN.countryCode] = countries.IRAN;
        countries.map[countries.IRAQ.countryCode] = countries.IRAQ;
        countries.map[countries.IRELAND.countryCode] = countries.IRELAND;
        countries.map[countries.ICELAND.countryCode] = countries.ICELAND;
        countries.map[countries.ISRAEL.countryCode] = countries.ISRAEL;
        countries.map[countries.ITALIA.countryCode] = countries.ITALIA;
        countries.map[countries.JAMAICA.countryCode] = countries.JAMAICA;
        countries.map[countries.JAPAN.countryCode] = countries.JAPAN;
        countries.map[countries.JERSEY.countryCode] = countries.JERSEY;
        countries.map[countries.JORDAN.countryCode] = countries.JORDAN;
        countries.map[countries.KAZAKHSTAN.countryCode] = countries.KAZAKHSTAN;
        countries.map[countries.KENYA.countryCode] = countries.KENYA;
        countries.map[countries.KYRGYZSTAN.countryCode] = countries.KYRGYZSTAN;
        countries.map[countries.KIRIBATI.countryCode] = countries.KIRIBATI;
        countries.map[countries.KUWAIT.countryCode] = countries.KUWAIT;
        countries.map[countries.LAO.countryCode] = countries.LAO;
        countries.map[countries.LESOTHO.countryCode] = countries.LESOTHO;
        countries.map[countries.LATVIA.countryCode] = countries.LATVIA;
        countries.map[countries.LEBANON.countryCode] = countries.LEBANON;
        countries.map[countries.LIBERIA.countryCode] = countries.LIBERIA;
        countries.map[countries.LIBYA.countryCode] = countries.LIBYA;
        countries.map[countries.LIECHTENSTEIN.countryCode] = countries.LIECHTENSTEIN;
        countries.map[countries.LITHUANIA.countryCode] = countries.LITHUANIA;
        countries.map[countries.MACAU.countryCode] = countries.MACAU;
        countries.map[countries.MACEDONIA.countryCode] = countries.MACEDONIA;
        countries.map[countries.MADAGASCAR.countryCode] = countries.MADAGASCAR;
        countries.map[countries.MALISIA.countryCode] = countries.MALISIA;
        countries.map[countries.MALAWI.countryCode] = countries.MALAWI;
        countries.map[countries.MALDIVES.countryCode] = countries.MALDIVES
        countries.map[countries.MALI.countryCode] = countries.MALI;
        countries.map[countries.MALTA.countryCode] = countries.MALTA;
        countries.map[countries.NORTHERNMARIANAISLANDS.countryCode] = countries.NORTHERNMARIANAISLANDS;
        countries.map[countries.MAROCO.countryCode] = countries.MAROCO;
        countries.map[countries.MARSHALL.countryCode] = countries.MARSHALL;
        countries.map[countries.MARTINIQUE.countryCode] = countries.MARTINIQUE;
        countries.map[countries.MAURITIUS.countryCode] = countries.MAURITIUS;
        countries.map[countries.MAURITANIA.countryCode] = countries.MAURITANIA;
        countries.map[countries.MAYOTTE.countryCode] = countries.MAYOTTE;
        countries.map[countries.MEXICO.countryCode] = countries.MEXICO;
        countries.map[countries.MICRONESIAFEDERALSTATESOF.countryCode] = countries.MICRONESIAFEDERALSTATESOF;
        countries.map[countries.MOLDOVA.countryCode] = countries.MOLDOVA;
        countries.map[countries.MONACO.countryCode] = countries.MONACO;
        countries.map[countries.MONGOLIA.countryCode] = countries.MONGOLIA;
        countries.map[countries.MONTENEGRO.countryCode] = countries.MONTENEGRO;
        countries.map[countries.MONTSERRAT.countryCode] = countries.MONTSERRAT;
        countries.map[countries.MOZAMBIQUE.countryCode] = countries.MOZAMBIQUE;
        countries.map[countries.MYNAMAR.countryCode] = countries.MYNAMAR;
        countries.map[countries.NAMIBIA.countryCode] = countries.NAMIBIA;
        countries.map[countries.NAURU.countryCode] = countries.NAURU.countryCode;
        countries.map[countries.NEPAL.countryCode] = countries.NEPAL;
        countries.map[countries.NICARAGUA.countryCode] = countries.NICARAGUA;
        countries.map[countries.NIGER.countryCode] = countries.NIGER;
        countries.map[countries.NIGERIA.countryCode] = countries.NIGERIA;
        countries.map[countries.NIUE.countryCode] = countries.NIUE;
        countries.map[countries.NOFOLKISLAND.countryCode] = countries.NOFOLKISLAND;
        countries.map[countries.NORWAY.countryCode] = countries.NORWAY;
        countries.map[countries.NEWCALEDONIA.countryCode] = countries.NEWCALEDONIA;
        countries.map[countries.NEWZEALAND.countryCode] = countries.NEWZEALAND;
        countries.map[countries.BRITISHINDIANOCEANTERRITORY.countryCode] = countries.BRITISHINDIANOCEANTERRITORY;
        countries.map[countries.OMAN.countryCode] = countries.OMAN;
        countries.map[countries.UGANDA.countryCode] = countries.UGANDA;
        countries.map[countries.UZBEKISTAN.countryCode] = countries.UZBEKISTAN;
        countries.map[countries.PAKISTAN.countryCode] = countries.PAKISTAN;
        countries.map[countries.PALAU.countryCode] = countries.PALAU;
        countries.map[countries.PALESTINIANTERRITORIES.countryCode] = countries.PALESTINIANTERRITORIES;
        countries.map[countries.PANAMA.countryCode] = countries.PANAMA;
        countries.map[countries.PAPUANEWGUINEA.countryCode] = countries.PAPUANEWGUINEA;
        countries.map[countries.PARAGUAY.countryCode] = countries.PARAGUAY;
        countries.map[countries.NETHERLANDS.countryCode] = countries.NETHERLANDS;
        countries.map[countries.PERU.countryCode] = countries.PERU;
        countries.map[countries.PHILIPPINES.countryCode] = countries.PHILIPPINES;
        countries.map[countries.PITCAIRNISLAND.countryCode] = countries.PITCAIRNISLAND;
        countries.map[countries.POLAND.countryCode] = countries.POLAND;
        countries.map[countries.FRENCHPOLYNESIA.countryCode] = countries.FRENCHPOLYNESIA;
        countries.map[countries.PORTORICO.countryCode] = countries.PORTORICO;
        countries.map[countries.PORTUGAL.countryCode] = countries.PORTUGAL;
        countries.map[countries.QATAR.countryCode] = countries.QATAR;
        countries.map[countries.REUNIONISLAND.countryCode] = countries.REUNIONISLAND;
        countries.map[countries.ROMANIA.countryCode] = countries.ROMANIA;
        countries.map[countries.UNITEDKINGDOM.countryCode] = countries.UNITEDKINGDOM;
        countries.map[countries.RUSSIA.countryCode] = countries.RUSSIA;
        countries.map[countries.RWANDA.countryCode] = countries.RWANDA;
        countries.map[countries.WESTERNSAHARA.countryCode] = countries.WESTERNSAHARA;
        countries.map[countries.STBARTHOLOMEW.countryCode] = countries.STBARTHOLOMEW;
        countries.map[countries.SAINTHELENA.countryCode] = countries.SAINTHELENA;
        countries.map[countries.STLUCIA.countryCode] = countries.STLUCIA;
        countries.map[countries.STKITTS.countryCode] = countries.STKITTS;
        countries.map[countries.STMARINO.countryCode] = countries.STMARINO;
        countries.map[countries.STMARINOFRENCHPART.countryCode] = countries.STMARINOFRENCHPART;
        countries.map[countries.STMARINODUTCHPART.countryCode] = countries.STMARINODUTCHPART;
        countries.map[countries.SAINTPIERREANDMIQUELON.countryCode] = countries.SAINTPIERREANDMIQUELON;
        countries.map[countries.HOLYSEESTATEOFTHECITYOFVATICAN.countryCode] = countries.HOLYSEESTATEOFTHECITYOFVATICAN;
        countries.map[countries.SAINTVINCENTANDTHEGRENADINES.countryCode] = countries.SAINTVINCENTANDTHEGRENADINES;
        countries.map[countries.SOLOMONISLANDS.countryCode] = countries.SOLOMONISLANDS;
        countries.map[countries.SAMOA.countryCode] = countries.SAMOA;
        countries.map[countries.AMERICANSAMOA.countryCode] = countries.AMERICANSAMOA;
        countries.map[countries.SAOTOMEANDPRINCIPE.countryCode] = countries.SAOTOMEANDPRINCIPE;
        countries.map[countries.SENEGAL.countryCode] = countries.SENEGAL;
        countries.map[countries.SERBIA.countryCode] = countries.SERBIA;
        countries.map[countries.SEYCHELLES.countryCode] = countries.SEYCHELLES;
        countries.map[countries.SIERRALEONE.countryCode] = countries.SIERRALEONE;
        countries.map[countries.SINGAPORE.countryCode] = countries.SINGAPORE;
        countries.map[countries.SLOVAKIA.countryCode] = countries.SLOVAKIA;
        countries.map[countries.SLOVENIA.countryCode] = countries.SLOVENIA;
        countries.map[countries.SOMALIA.countryCode] = countries.SOMALIA;
        countries.map[countries.SUDAN.countryCode] = countries.SUDAN;
        countries.map[countries.SOUTHSUDAN.countryCode] = countries.SOUTHSUDAN;
        countries.map[countries.SRILANKA.countryCode] = countries.SRILANKA;
        countries.map[countries.SWEDEN.countryCode] = countries.SWEDEN;
        countries.map[countries.SURINAME.countryCode] = countries.SURINAME;
        countries.map[countries.SVALBARDANDJANMAYEN.countryCode] = countries.SVALBARDANDJANMAYEN;
        countries.map[countries.SWAZILAND.countryCode] = countries.SWAZILAND;
        countries.map[countries.SYRIA.countryCode] = countries.SYRIA;
        countries.map[countries.TAJIKISTAN.countryCode] = countries.TAJIKISTAN;
        countries.map[countries.TAIWAN.countryCode] = countries.TAIWAN;
        countries.map[countries.TANZANIA.countryCode] = countries.TANZANIA,
            countries.map[countries.CHAD.countryCode] = countries.CHAD;
        countries.map[countries.BELIZE.countryCode] = countries.BELIZE;
        countries.map[countries.FRENCHSOUTHERNTERRITORIES.countryCode] = countries.FRENCHSOUTHERNTERRITORIES;
        countries.map[countries.THAILAND.countryCode] = countries.THAILAND;
        countries.map[countries.TIMORLESTE.countryCode] = countries.TIMORLESTE;
        countries.map[countries.TOGO.countryCode] = countries.TOGO;
        countries.map[countries.TOKELAU.countryCode] = countries.TOKELAU;
        countries.map[countries.TONGA.countryCode] = countries.TONGA;
        countries.map[countries.TRINIDADANDTOBAGO.countryCode] = countries.TRINIDADANDTOBAGO;
        countries.map[countries.TUNISIA.countryCode] = countries.TUNISIA;
        countries.map[countries.TURKMENISTAN.countryCode] = countries.TURKMENISTAN;
        countries.map[countries.TURKSANDCAICOSISLANDS.countryCode] = countries.TURKSANDCAICOSISLANDS;
        countries.map[countries.TURKEY.countryCode] = countries.TURKEY;
        countries.map[countries.TUVALU.countryCode] = countries.TUVALU;
        countries.map[countries.UKRAINE.countryCode] = countries.UKRAINE;
        countries.map[countries.URUGUAY.countryCode] = countries.URUGUAY;
        countries.map[countries.VANUATU.countryCode] = countries.VANUATU;
        countries.map[countries.VENEZUELA.countryCode] = countries.VENEZUELA;
        countries.map[countries.VIETNAM.countryCode] = countries.VIETNAM;
        countries.map[countries.WALLISANDFUTUNAISLANDS.countryCode] = countries.WALLISANDFUTUNAISLANDS;
        countries.map[countries.YEMEN.countryCode] = countries.YEMEN;
        countries.map[countries.ZAMBIA.countryCode] = countries.ZAMBIA;
        countries.map[countries.ZIMBABWE.countryCode] = countries.ZIMBABWE;

        countries.list = [];
        for (var countryCode in countries.map) {
            countries.list.push(countries.map[countryCode]);
        }
        return countries;
    }]);
angular.module('FlexyBeautyApp.services').factory('LocaleList', [
    function () {
        let localeList = [
            {languageName: "Albanais", languageCode: "sq", countryName: "Albanie", countryCode: "AL", localeCode: "sq-AL", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Algérie", countryCode: "DZ", localeCode: "ar-DZ", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Bahreïn", countryCode: "BH", localeCode: "ar-BH", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Egypte", countryCode: "EG", localeCode: "ar-EG", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Irak", countryCode: "QI", localeCode: "ar-QI", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Jordan", countryCode: "JO", localeCode: "ar-JO", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Koweït", countryCode: "KW", localeCode: "ar-KW", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Liban", countryCode: "LB", localeCode: "ar-LB", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Libye", countryCode: "LY", localeCode: "ar-LY", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Maroc", countryCode: "MA", localeCode: "ar-MA", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Oman", countryCode: "OM", localeCode: "ar-OM", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Qatar", countryCode: "QA", localeCode: "ar-QA", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Arabie Saoudite", countryCode: "SA", localeCode: "ar-SA", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Soudan", countryCode: "SD", localeCode: "ar-SD", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Syrie", countryCode: "SY", localeCode: "ar-SY", isSupported: false},
            {languageName: "Arabe", languageCode: "ar", countryName: "Tunisie", countryCode: "TN", localeCode: "ar-TN", isSupported: false},
            {
                languageName: "Arabe",
                languageCode: "ar",
                countryName: "Emirats Arabes Unis",
                countryCode: "AE",
                localeCode: "ar-AE",
                isSupported: false
            },
            {languageName: "Arabe", languageCode: "ar", countryName: "Yémen", countryCode: "YE", localeCode: "ar-YE", isSupported: false},
            {languageName: "Biélorusse", languageCode: "be", countryName: "Biélorussie", countryCode: "BY", localeCode: "be-BY", isSupported: false},
            {languageName: "Bulgare", languageCode: "bg", countryName: "Bulgarie", countryCode: "BG", localeCode: "bg-bg", isSupported: false},
            {languageName: "Catalan", languageCode: "ca", countryName: "Espagne", countryCode: "ES", localeCode: "ca-ES", isSupported: false},
            {languageName: "Chinois", languageCode: "zh", countryName: "Chine", countryCode: "CN", localeCode: "zh-CN", isSupported: false},
            {languageName: "Chinois", languageCode: "zh", countryName: "Singapour", countryCode: "SG", localeCode: "zh-SG", isSupported: false},
            {languageName: "Chinois", languageCode: "zh", countryName: "Hong Kong", countryCode: "HK", localeCode: "zh-HK", isSupported: false},
            {languageName: "Chinois", languageCode: "zh", countryName: "Taiwan", countryCode: "TW", localeCode: "zh-TW", isSupported: false},
            {languageName: "Croate", languageCode: "hr", countryName: "Croatie", countryCode: "HR", localeCode: "HR-HR", isSupported: false},
            {
                languageName: "Tchèque",
                languageCode: "cs",
                countryName: "République tchèque",
                countryCode: "CZ",
                localeCode: "cs-cz",
                isSupported: false
            },
            {languageName: "Danois", languageCode: "da", countryName: "Danemark", countryCode: "DK", localeCode: "da-DK", isSupported: false},
            {languageName: "Néerlandais", languageCode: "nl", countryName: "Belgique", countryCode: "BE", localeCode: "nl-BE", isSupported: true},
            {languageName: "Néerlandais", languageCode: "nl", countryName: "Pays-Bas", countryCode: "NL", localeCode: "NL-NL", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Australie", countryCode: "AU", localeCode: "en-AU", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Canada", countryCode: "CA", localeCode: "en-CA", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Inde", countryCode: "IN", localeCode: "en-IN", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Irlande", countryCode: "IE", localeCode: "en-IE", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Malte", countryCode: "MT", localeCode: "en-MT", isSupported: false},
            {
                languageName: "Anglais",
                languageCode: "en",
                countryName: "Nouvelle Zélande",
                countryCode: "NZ",
                localeCode: "en-NZ",
                isSupported: false
            },
            {languageName: "Anglais", languageCode: "en", countryName: "Philippines", countryCode: "PH", localeCode: "en-PH", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Singapour", countryCode: "SG", localeCode: "en-SG", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Afrique du Sud", countryCode: "ZA", localeCode: "en-ZA", isSupported: false},
            {languageName: "Anglais", languageCode: "en", countryName: "Royaume-Uni", countryCode: "GB", localeCode: "en-GB", isSupported: true},
            {languageName: "Anglais", languageCode: "en", countryName: "États-Unis", countryCode: "US", localeCode: "en-US", isSupported: false},
            {languageName: "Estonien", languageCode: "et", countryName: "Estonie", countryCode: "EE", localeCode: "et-EE", isSupported: false},
            {languageName: "Finlandais", languageCode: "fi", countryName: "Finlande", countryCode: "FI", localeCode: "fi-FI", isSupported: false},
            {languageName: "Français", countryName: "Belgique", countryCode: "BE", localeCode: "fr-BE", isSupported: false},
            {languageName: "Français", countryName: "Canada", countryCode: "CA", localeCode: "fr-CA", isSupported: false},
            {languageName: "Français", countryName: "France", countryCode: "FR", localeCode: "fr-FR", isSupported: true},
            {languageName: "Français", countryName: "Luxembourg", countryCode: "LU", localeCode: "fr-LU", isSupported: false},
            {languageName: "Français", countryName: "Suisse", countryCode: "CH", localeCode: "fr-CH", isSupported: true},
            {languageName: "Allemand", languageCode: "de", countryName: "Autriche", countryCode: "AT", localeCode: "de-AT", isSupported: false},
            {languageName: "Allemand", languageCode: "de", countryName: "Allemagne", countryCode: "DE", localeCode: "de-DE", isSupported: false},
            {languageName: "Allemand", languageCode: "de", countryName: "Luxembourg", countryCode: "LU", localeCode: "de-LU", isSupported: false},
            {languageName: "Allemand", languageCode: "de", countryName: "Suisse", countryCode: "CH", localeCode: "de-CH", isSupported: false},
            {languageName: "Grec", languageCode: "el", countryName: "Chypre", countryCode: "CY", localeCode: "el-CY", isSupported: false},
            {languageName: "Grec", languageCode: "el", countryName: "Grèce", countryCode: "GR", localeCode: "el-GR", isSupported: false},
            {languageName: "Hébreu", languageCode: "iw", countryName: "Israël", countryCode: "IL", localeCode: "iw-IL", isSupported: false},
            {languageName: "Hindi", languageCode: "salut", countryName: "Inde", countryCode: "IN", localeCode: "Salut dans", isSupported: false},
            {languageName: "Hongrois", languageCode: "hu", countryName: "Hongrie", countryCode: "HU", localeCode: "hu-HU", isSupported: false},
            {languageName: "Islandais", languageCode: "est", countryName: "Islande", countryCode: "IS", localeCode: "is-is", isSupported: false},
            {languageName: "Indonésien", languageCode: "en", countryName: "Indonésie", countryCode: "ID", localeCode: "in-ID", isSupported: false},
            {languageName: "Irlandais", languageCode: "ga", countryName: "Irlande", countryCode: "IE", localeCode: "ga-IE", isSupported: false},
            {languageName: "Italien", languageCode: "le", countryName: "Italie", countryCode: "IT", localeCode: "ça ça", isSupported: false},
            {languageName: "Italien", languageCode: "le", countryName: "Suisse", countryCode: "CH", localeCode: "démanger", isSupported: false},
            {languageName: "Japonais", languageCode: "ja", countryName: "Japon", countryCode: "JP", localeCode: "ja-JP", isSupported: false},
            {
                languageName: "Japonais",
                languageCode: "ja",
                countryName: "Japon",
                countryCode: "JP",
                localeCode: "ja-JP-u-ca-japanese",
                isSupported: false
            },
            {
                languageName: "Japonais",
                languageCode: "ja",
                countryName: "Japon",
                countryCode: "JP",
                localeCode: "ja-JP-x-lvariant-JP",
                isSupported: false
            },
            {languageName: "Coréen", languageCode: "ko", countryName: "Corée du Sud", countryCode: "KR", localeCode: "ko-kr", isSupported: false},
            {languageName: "Letton", languageCode: "lv", countryName: "Lettonie", countryCode: "LV", localeCode: "LV-LV", isSupported: false},
            {languageName: "Lituanien", languageCode: "lt", countryName: "Lituanie", countryCode: "LT", localeCode: "LT-LT", isSupported: false},
            {languageName: "Macédonien", languageCode: "mk", countryName: "Macédoine", countryCode: "MK", localeCode: "MK-MK", isSupported: false},
            {languageName: "Malais", languageCode: "ms", countryName: "Malaisie", countryCode: "MY", localeCode: "ms-MY", isSupported: false},
            {languageName: "Maltais", languageCode: "mt", countryName: "Malte", countryCode: "MT", localeCode: "mt-MT", isSupported: false},
            {languageName: "Norvégien", languageCode: "non", countryName: "Norvège", countryCode: "NO", localeCode: "non non", isSupported: false},
            {languageName: "Norvégien bokmål", countryName: "Norvège", countryCode: "NO", localeCode: "nb-NO", isSupported: false},
            {
                languageName: "Nynorsk norvégien",
                languageCode: "nn",
                countryName: "Norvège",
                countryCode: "NO",
                localeCode: "nn-NO",
                isSupported: false
            },
            {
                languageName: "Norvégien",
                languageCode: "non",
                countryName: "Norvège",
                countryCode: "NO",
                localeCode: "no-NO-x-lvariant-NY",
                isSupported: false
            },
            {languageName: "Polonais", languageCode: "pl", countryName: "Pologne", countryCode: "PL", localeCode: "pl-PL", isSupported: false},
            {languageName: "Portugais", languageCode: "pt", countryName: "Brésil", countryCode: "BR", localeCode: "pt-BR", isSupported: false},
            {languageName: "Portugais", languageCode: "pt", countryName: "Portugal", countryCode: "PT", localeCode: "pt-PT", isSupported: false},
            {languageName: "Roumain", languageCode: "ro", countryName: "Roumanie", countryCode: "RO", localeCode: "ro-ro", isSupported: false},
            {languageName: "Russe", languageCode: "ru", countryName: "Russie", countryCode: "RU", localeCode: "ru-RU", isSupported: false},
            {
                languageName: "Serbe",
                languageCode: "sr",
                countryName: "Bosnie-Herzégovine",
                countryCode: "BA",
                localeCode: "sr-BA",
                isSupported: false
            },
            {languageName: "Serbe", languageCode: "sr", countryName: "Monténégro", countryCode: "ME", localeCode: "sr-me", isSupported: false},
            {languageName: "Serbe", languageCode: "sr", countryName: "Serbie", countryCode: "RS", localeCode: "sr-RS", isSupported: false},
            {
                languageName: "Serbe",
                languageCode: "sr",
                countryName: "Bosnie-Herzégovine",
                countryCode: "BA",
                localeCode: "sr-Latn-BA",
                isSupported: false
            },
            {languageName: "Serbe", languageCode: "sr", countryName: "Monténégro", countryCode: "ME", localeCode: "sr-Latn-ME", isSupported: false},
            {languageName: "Serbe", languageCode: "sr", countryName: "Serbie", countryCode: "RS", localeCode: "Sr-Latn-RS", isSupported: false},
            {languageName: "Slovaque", languageCode: "sk", countryName: "Slovaquie", countryCode: "SK", localeCode: "sk-SK", isSupported: false},
            {languageName: "Slovène", languageCode: "sl", countryName: "Slovénie", countryCode: "SI", localeCode: "sl-SI", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Argentine", countryCode: "AR", localeCode: "es-AR", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Bolivie", countryCode: "BO", localeCode: "es-BO", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Chili", countryCode: "CL", localeCode: "es-CL", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Colombie", countryCode: "CO", localeCode: "es-CO", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Costa Rica", countryCode: "CR", localeCode: "es-CR", isSupported: false},
            {
                languageName: "Espagnol",
                languageCode: "es",
                countryName: "République dominicaine",
                countryCode: "DO",
                localeCode: "es-DO",
                isSupported: false
            },
            {languageName: "Espagnol", languageCode: "es", countryName: "Équateur", countryCode: "CE", localeCode: "es-EC", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Salvador", countryCode: "SV", localeCode: "es-SV", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Guatemala", countryCode: "GT", localeCode: "es-GT", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Honduras", countryCode: "HN", localeCode: "es-HN", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Mexique", countryCode: "MX", localeCode: "es-MX", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Nicaragua", countryCode: "NL", localeCode: "es-NI", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Panama", countryCode: "PA", localeCode: "es-PA", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Paraguay", countryCode: "PY", localeCode: "es-PY", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Pérou", countryCode: "PE", localeCode: "es-PE", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Porto Rico", countryCode: "PR", localeCode: "es-PR", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Espagne", countryCode: "ES", localeCode: "es-ES", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "États-Unis", countryCode: "US", localeCode: "es-US", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Uruguay", countryCode: "UY", localeCode: "es-UY", isSupported: false},
            {languageName: "Espagnol", languageCode: "es", countryName: "Venezuela", countryCode: "VE", localeCode: "es-VE", isSupported: false},
            {languageName: "Suédois", languageCode: "sv", countryName: "Suède", countryCode: "SE", localeCode: "sv-SE", isSupported: false},
            {languageName: "Thaï", languageCode: "th", countryName: "Thaïlande", countryCode: "TH", localeCode: "th-TH", isSupported: false},
            {
                languageName: "Thaï",
                languageCode: "th",
                countryName: "Thaïlande",
                countryCode: "TH",
                localeCode: "th-th-u-ca-bouddhiste",
                isSupported: false
            },
            {
                languageName: "Thaï",
                languageCode: "th",
                countryName: "Thaïlande",
                countryCode: "TH",
                localeCode: "th-TH-u-ca-bouddhiste-nu-thai",
                isSupported: false
            },
            {
                languageName: "Thaï",
                languageCode: "th",
                countryName: "Thaïlande",
                countryCode: "TH",
                localeCode: "th-TH-x-lvariant-TH",
                isSupported: false
            },
            {languageName: "Turc", languageCode: "tr", countryName: "Turquie", countryCode: "TR", localeCode: "tr-TR", isSupported: false},
            {languageName: "Ukrainien", countryName: "Ukraine", countryCode: "UA", localeCode: "uk-UA", isSupported: false},
            {languageName: "Vietnamien", languageCode: "vi", countryName: "Vietnam", countryCode: "VN", localeCode: "vi-VN"}]
        return localeList;
    }]);
angular.module('FlexyBeautyApp.services').factory('LanguageApplicationList', [
    function () {
        let languageApplicationList = [
            {languageName: "Anglais", countryName: "Royaume-Uni", localeCode: "en-GB"},
            {languageName: "Français", countryName: "France", localeCode: "fr-FR"}]
        return languageApplicationList;
    }]);
angular.module('FlexyBeautyApp.services').factory('LanguageManagerSrv', ["LanguageManager_Resource",
    function (LanguageManager_Resource) {
        let languageManagerSrv = {};

        languageManagerSrv.getJsonFile = function (languageCode, countryCode) {
            return LanguageManager_Resource.getJsonFile({
                languageCode: languageCode,
                countryCode: countryCode
            }).$promise;
        };
        return languageManagerSrv;
    }]);
angular.module('FlexyBeautyApp.services')
    .factory('SupportedLocales', [function () {
        let supportedLocales = [];

        supportedLocales["fr"] = [];
        supportedLocales["fr"]["FR"] = {
            languageCode: 'fr',
            countryCode: 'FR',
            facebookLocale: "fr_fr",
            angularLocale: "fr",
            momentLocale: "fr",
            gettextLocale: "fr",
            googleChartLocale: "fr"
        };

        supportedLocales["fr"]["CH"] = {
            languageCode: 'fr',
            countryCode: 'CH',
            facebookLocale: "fr_fr",
            angularLocale: "fr-ch",
            momentLocale: "fr-ch",
            gettextLocale: "fr",
            googleChartLocale: "fr"
        };

        supportedLocales["en"] = [];

        supportedLocales["en"]["US"] = {
            languageCode: 'en',
            countryCode: 'US',
            facebookLocale: "en_US",
            angularLocale: "en-us",
            momentLocale: "en",
            gettextLocale: "en_US",
            googleChartLocale: "en"
        };

        supportedLocales["en"]["GB"] = {
            languageCode: 'en',
            countryCode: 'GB',
            facebookLocale: "en",
            angularLocale: "en-gb",
            momentLocale: "en-gb",
            gettextLocale: "en_GB",
            googleChartLocale: "en"
        };

        supportedLocales["de"] = [];
        supportedLocales["de"]["DE"] = {
            languageCode: 'de',
            countryCode: 'DE',
            facebookLocale: "de",
            angularLocale: "de",
            momentLocale: "de",
            gettextLocale: "de",
            googleChartLocale: "de"
        };

        supportedLocales["es"] = [];
        supportedLocales["es"]["ES"] = {
            languageCode: 'es',
            countryCode: 'ES',
            facebookLocale: "es_LA",
            angularLocale: "es",
            momentLocale: "es",
            gettextLocale: "es",
            googleChartLocale: "es"
        };

        supportedLocales["nl"] = [];
        supportedLocales["nl"]["BE"] = {
            languageCode: 'nl',
            countryCode: 'BE',
            facebookLocale: "nl_BE",
            angularLocale: "nl-be",
            momentLocale: "nl-be",
            gettextLocale: "nl",
            googleChartLocale: "nl"
        };

        return supportedLocales;
    }]);
angular.module('FlexyBeautyApp.services')
    .factory('LanguageManager', ['$cookies', 'gettextCatalog', '$locale', '$http', 'tmhDynamicLocale', 'LanguageManagerSrv', 'SupportedLocales', '$location',
        'LaunchDarklyFeatureFlagData', 'LaunchDarklyFeatureFlagList', 'Decorators', 'TimeMeasures', 'moment', 'PhoneFormat',
        function ($cookies, gettextCatalog, $locale, $http, tmhDynamicLocale, LanguageManagerSrv, SupportedLocales, $location,
                  LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagList, Decorators, TimeMeasures, moment, PhoneFormat) {
            let languageManager = {
                locale: null,
                intlNumberFormatter: null,
                LOCALE_SEPARATOR: "-"
            };

            languageManager.getLanguageCode = function () {
                return this.locale ? this.locale.languageCode : null;
            };

            languageManager.getCountryCode = function () {
                return this.locale ? this.locale.countryCode : null;
            };

            languageManager.initAcceptLanguage = function (user) {
                return new Promise((resolve, reject) => {
                    if (user && user.company && user.company.localeCode) {
                        $http.defaults.headers.common["Accept-Language"] = user.company.localeCode;
                        PhoneFormat.setLocalCountry(user.company.country);
                        this.initLanguageManager(user.company.localeCode).then(resolve, reject);
                    } else {
                        resolve();
                    }
                });
            };

            languageManager.setLocale = Decorators.timeMeasureDecorator(
                function (localeCode) {
                    let languageCode,
                        countryCode;

                    if (localeCode) {
                        let localeSplit = localeCode.split(this.LOCALE_SEPARATOR);
                        const languageIndex = 0,
                            countryIndex = 1;
                        languageCode = localeSplit[languageIndex];
                        countryCode = localeSplit[countryIndex];
                    }
                    //loading of the correct language
                    if (languageCode && countryCode && SupportedLocales[languageCode][countryCode]) {
                        this.locale = SupportedLocales[languageCode][countryCode];
                    } else {
                        this.locale = SupportedLocales["fr"]["FR"];
                    }
                }, TimeMeasures.LANGUAGE_MANAGER_SET_LOCALE
            );

            languageManager.loadMomentWithCorrectLocale = Decorators.timeMeasureDecorator(
                function () {
                    moment.locale(this.locale.momentLocale);
                }, TimeMeasures.LANGUAGE_MANAGER_LOAD_MOMENT
            );

            languageManager.loadGoogleChartsWithCorrectLocale = Decorators.timeMeasureDecorator(
                function () {
                    return new Promise((resolve) => {
                        try {
                            google.charts.load('48', {
                                packages: ['corechart', 'table', 'gauge'],
                                language: this.locale.googleChartLocale,
                                callback: resolve
                            });
                        } catch (e) {
                            console.warn("Failed to Google Charts ");
                        }
                    });
                }, TimeMeasures.LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS
            );

            languageManager.loadAngularDynamicLocaleWithCorrectLocale = Decorators.timeMeasureDecorator(
                function () {
                    return tmhDynamicLocale.set(this.locale.angularLocale);
                }, TimeMeasures.LANGUAGE_MANAGER_LOAD_ANGULAR
            );

            languageManager.loadDictionaryWithCorrectLocale = Decorators.timeMeasureDecorator(
                function () {
                    let loadDictionarySuccess = function (data) {
                        if (data && data.json) {
                            let jsonData = JSON.parse(data.json);
                            gettextCatalog.setStrings(data.language, jsonData);
                            gettextCatalog.setCurrentLanguage(data.language);
                            console.info("Current language " + gettextCatalog.getCurrentLanguage());
                        }
                    };

                    return LanguageManagerSrv.getJsonFile(this.locale.languageCode, this.locale.countryCode).then(loadDictionarySuccess);
                }, TimeMeasures.LANGUAGE_MANAGER_LOAD_DICTIONARY
            );

            languageManager.initLanguageManager = Decorators.timeMeasureDecorator(
                function (localeCode) {
                    this.setLocale(localeCode);

                    this.setIntlNumberFormatter();

                    this.loadMomentWithCorrectLocale();

                    let promises = [];

                    promises.push(this.loadGoogleChartsWithCorrectLocale());

                    promises.push(this.loadAngularDynamicLocaleWithCorrectLocale());

                    promises.push(this.loadDictionaryWithCorrectLocale());

                    return Promise.all(promises);
                }, TimeMeasures.LANGUAGE_MANAGER_INITIALISATION
            );

            languageManager.getGetTextLocale = function () {
                return this.locale.gettextLocale;
            };

            languageManager.getLocale = function () {
                return this.getLanguageCode() + this.LOCALE_SEPARATOR + this.getCountryCode();
            };

            //Mock for Oui/Non toggle buttons
            languageManager.isEnglishLanguage = function () {
                return (this.getLanguageCode() && this.getLanguageCode().indexOf("en") !== -1);
            };

            languageManager.isFrenchLanguage = function () {
                return (this.getLanguageCode() && this.getLanguageCode().indexOf("fr") !== -1);
            };

            languageManager.isDutchLanguage = function () {
                return (this.getLanguageCode() && this.getLanguageCode().indexOf("nl") !== -1);
            };

            languageManager.canAccessLiveEdit = function () {
                let displayLiveEdit = false,
                    absUrl = $location.absUrl();//don't work on website in appPro but top.document.location.href don't work on all website

                if (absUrl.indexOf("/fxbAdmin/") !== -1 && !this.isFrenchLanguage()) {
                    displayLiveEdit = true;
                }

                return displayLiveEdit;
            };

            languageManager.setIntlNumberFormatter = Decorators.timeMeasureDecorator(
                function () {
                    try {
                        if (Intl && typeof Intl === 'object' && Intl.NumberFormat && typeof Intl.NumberFormat === 'function' && Intl.NumberFormat.prototype.hasOwnProperty("formatToParts") && Intl.NumberFormat.prototype.hasOwnProperty("format")) {
                            this.intlNumberFormatter = Intl.NumberFormat(this.getLocale());
                        }
                    } catch (e) {
                        //sometimes some browsers (mobile safari) throw an exception " ReferenceError · Can't find variable: Intl" despite of the test above
                        //if it occurs an exception with Intl, we force the intlNumberFormatter to null in order to format the number with the "old method"
                        this.intlNumberFormatter = null;
                    }
                }, TimeMeasures.LANGUAGE_MANAGER_SET_NUMBER_FORMATTER
            );


            languageManager.getIntlNumberFormatter = function () {
                return this.intlNumberFormatter;
            };

            return languageManager;
        }]);



// WEBPACK FOOTER //
// ./js/services/tools/LanguageManager.js